import { c as _c } from "react/compiler-runtime";
import { Typography } from "@/shared/ui/atoms";
import Image from "next/image";
import Link from "next/link";
import { TreatmentCaseSummaryResponse } from "@/shared/types/type/treatment";
import { useLocale } from "next-intl";
interface AllTreatmentCarouselCardProps {
  summary: TreatmentCaseSummaryResponse;
  index: number;
}
const AllTreatmentCarouselCard = t0 => {
  const $ = _c(23);
  const {
    summary,
    index
  } = t0;
  const locale = useLocale();
  const {
    treatmentCaseId,
    hospitalOriginName,
    treatmentSubjectName,
    title,
    thumbnail,
    hospitalThumbnailUrl
  } = summary;
  const {
    beforeImageUrl,
    afterImageUrl
  } = thumbnail;
  const t1 = `/${locale}/treatment-case/${treatmentCaseId}`;
  let t2;
  if ($[0] !== hospitalThumbnailUrl) {
    t2 = <div className="relative w-[24px] h-[24px] flex items-center justify-center rounded-full overflow-hidden before:content-[''] before:absolute before:top-0 before:left-0 before:w-full before:h-full before:bg-gray-200 before:rounded-full"><Image src={hospitalThumbnailUrl} alt={"\uBCD1\uC6D0 \uB85C\uACE0"} fill={true} sizes="24px" className="object-cover" /></div>;
    $[0] = hospitalThumbnailUrl;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== hospitalOriginName) {
    t3 = <Typography size={14} lineHeight={22} className="text-gray-900 font-medium">{hospitalOriginName}</Typography>;
    $[2] = hospitalOriginName;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t2 || $[5] !== t3) {
    t4 = <div className="flex items-center gap-1.5 mb-3">{t2}{t3}</div>;
    $[4] = t2;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== afterImageUrl || $[8] !== beforeImageUrl || $[9] !== index) {
    t5 = <div className="relative w-[200px] h-[110px] flex items-center justify-center relative rounded-lg overflow-hidden before:content-[''] before:absolute before:top-0 before:left-0 before:w-full before:h-full before:bg-gray-200 before:rounded-lg">{afterImageUrl && beforeImageUrl ? <div className="relative flex items-center justify-center w-full h-full"><div className="relative flex-1 flex-shrink-0 w-full h-full"><Image src={beforeImageUrl} alt={"\uCE58\uB8CC \uC0AC\uB840"} fill={true} sizes="100px 110px" className="rounded-l-lg relative z-[1] absolute top-0 left-0" priority={index === 0} /><Typography size={11} lineHeight={12} className="absolute bottom-1.5 left-1.5 px-[5px] py-0.5 text-white text-medium z-[2] bg-[rgba(42,42,49,0.8)] rounded">Before</Typography></div><div className="relative flex-1 flex-shrink-0 w-full h-full"><Image src={afterImageUrl} alt={"\uCE58\uB8CC \uC0AC\uB840"} fill={true} sizes="100px 110px" className="rounded-r-lg relative z-[1] absolute top-0 left-0" priority={index === 0} /><Typography size={11} lineHeight={12} className="absolute bottom-1.5 right-1.5 px-[5px] py-0.5 text-white text-medium z-[2] bg-[rgba(42,42,49,0.8)] rounded">After</Typography></div></div> : <Image src={afterImageUrl ?? "/icons/logo.svg"} alt={"\uCE58\uB8CC \uC0AC\uB840"} fill={true} sizes="200px 110px" className="object-cover rounded-lg relative z-[1]" priority={index === 0} />}</div>;
    $[7] = afterImageUrl;
    $[8] = beforeImageUrl;
    $[9] = index;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== treatmentSubjectName) {
    t6 = <Typography size={14} lineHeight={22} className="text-primary-700 font-medium">{treatmentSubjectName}</Typography>;
    $[11] = treatmentSubjectName;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== title) {
    t7 = <Typography size={16} lineHeight={24} className="text-gray-800 font-medium line-clamp-2">{title}</Typography>;
    $[13] = title;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== t6 || $[16] !== t7) {
    t8 = <div className="mt-2.5 flex flex-col gap-1">{t6}{t7}</div>;
    $[15] = t6;
    $[16] = t7;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== t1 || $[19] !== t4 || $[20] !== t5 || $[21] !== t8) {
    t9 = <Link href={t1} className="block flex-shrink-0 max-w-[220px] px-2.5 pt-3 pb-5 bg-white rounded-lg">{t4}{t5}{t8}</Link>;
    $[18] = t1;
    $[19] = t4;
    $[20] = t5;
    $[21] = t8;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  return t9;
};
export default AllTreatmentCarouselCard;